import React from 'react';
import { IconButton } from '@mui/material';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';

import styles from './ReportsHeader.module.scss';
import { ChartViewSelect } from '../subcomponents';
import { ReportChartViewTypeEnum } from '../types';

type Props = {
  title: string;
  onBackClick: () => void;
  chartView: ReportChartViewTypeEnum;
  onChartViewChange: (view: ReportChartViewTypeEnum) => void;
};

export function ReportsHeader(props: Props) {
  const { title, onBackClick, chartView, onChartViewChange } = props;

  return (
    <div className={styles.header}>
      <div className={styles.navigation}>
        <IconButton color="primary" disableRipple onClick={onBackClick}>
          <ArrowBackIosIcon />
        </IconButton>
      </div>
      <span className={styles.title}>{title}</span>
      <ChartViewSelect value={chartView} onChange={onChartViewChange} />
    </div>
  );
}
